// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fb9c7072","845":"0a6960b8"}[chunkId] + ".chunk.js";
};